import CheckBox from './CheckBox.vue';

CheckBox.install = (Vue) => {
  Vue.component(CheckBox.name, CheckBox);
};

export default CheckBox;
